export default __webpack_public_path__ + "static/media/station_remote_control.8f4672cc.png";